import React from 'react';
import PropTypes from 'prop-types';

import './Card.css';

const CardHeaderC = (props) => {

  return (
    <div className={`card-header ${props.className || ''}`} automationid={`SalesLead_Div_${props.automationidattr}CardHeader_0`}>
      {props.children}
    </div>
  );
}

CardHeaderC.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string
}

export const CardHeader = CardHeaderC;
